module.exports = __webpack_public_path__ + "img/0-54.4c01b4de.jpg";